// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const renderMultiSelectLabel = <T extends { id: string; name: string }>(
    listItems: T[],
    options?: { valueGetter?: (option: T) => string; translate?: (text: string) => string }
): string => {
    switch (listItems.length) {
        case 0:
            return options?.translate?.("None selected") || "None selected";
        case 1:
            return options?.valueGetter?.(listItems[0]) || listItems[0].name;
        default:
            return listItems.reduce((cum, listItem, index) => {
                const text = options?.valueGetter?.(listItem) || listItem.name;
                if (index === 0) {
                    return cum.concat(text);
                }
                return cum.concat(`, ${text}`);
            }, "");
    }
};
